import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import EpisodeRow from './EpisodeRow';

export default class Seasons extends Component {
  static propTypes = {
    seasons: PropTypes.arrayOf(PropTypes.object),
    seasonCurrentId: PropTypes.string,
    srcIconDownload: PropTypes.string,
    canIDownloadEpisodes: PropTypes.bool,
    onClickEpisode: PropTypes.func.isRequired,
    onClickDownload: PropTypes.func.isRequired,
  };

  static defaultProps = {
    seasons: [],
    seasonCurrentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      tabIndex: this.props.seasons.findIndex(
        s => s.id === this.props.seasonCurrentId,
      ),
    };
    this.handleClickSelect = this.handleClickSelect.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.seasonCurrentId !== nextProps.seasonCurrentId) {
      this.setState({
        tabIndex: this.props.seasons.findIndex(
          s => s.id === this.props.seasonCurrentId,
        ),
      });
    }
  }

  handleClickSelect(tabIndex) {
    this.setState({ tabIndex });
  }

  render() {
    const {
      seasons,
      onClickEpisode,
      onClickDownload,
      canIDownloadEpisodes,
      srcIconDownload,
    } = this.props;
    const { tabIndex } = this.state;

    if (seasons.length === 0) {
      return null;
    }

    return (
      <div className="col-xs-12 card-view-container-seasons">
        <Tabs selectedIndex={tabIndex} onSelect={this.handleClickSelect}>
          <TabList>
            {seasons.map((season, index) => {
              const { title, id } = season;
              return <Tab key={`tab-season-${id}-${index}`}>{title}</Tab>;
            })}
          </TabList>
          {seasons.map((season, i) => {
            const { chapters, id } = season;

            return (
              <TabPanel key={`tab-panel-${id}-${i}`}>
                {chapters.map((chapter, index) => (
                  <EpisodeRow
                    key={`episode-${id}-row-${chapter.id}-${index}`}
                    {...chapter}
                    srcIconDownload={srcIconDownload}
                    canIDownload={canIDownloadEpisodes}
                    onClickEpisode={onClickEpisode}
                    onClickDownload={onClickDownload}
                  />
                ))}
              </TabPanel>
            );
          })}
        </Tabs>
      </div>
    );
  }
}
